import {
  BrandKit,
  ButtonHierarchy,
  ButtonStyleDefinition,
  Override,
  styleFromFontWeight,
} from "@redotech/redo-model/brand-kit";
import { CSSProperties } from "react";

export function getButtonStyles({
  brandKit,
  hierarchy,
  override,
  fullWidth = true,
}: {
  brandKit: BrandKit;
  hierarchy: ButtonHierarchy;
  override?: Override<ButtonStyleDefinition>;
  fullWidth?: boolean;
}): CSSProperties {
  const styles = override ? override : brandKit?.buttons[hierarchy];
  return {
    outline: "0px",
    backgroundColor: styles.backgroundColor,
    color: styles.textColor,
    border: `${styles.border.stroke.weightPx}px solid ${styles.border.stroke.color}`,
    borderRadius: `${styles.border.cornerRadiusPx}px`,
    width: fullWidth ? "100%" : "auto",
    fontFamily:
      "fontReference" in styles
        ? brandKit?.font.fontFamily
        : styles.font.fontFamily,
    fontSize: `${"fontReference" in styles ? brandKit?.font.hierarchy[styles.fontReference].fontSizePx : styles.font.fontSizePx}px`,
    fontWeight: styleFromFontWeight(
      "fontReference" in styles
        ? brandKit?.font.hierarchy[styles.fontReference].fontWeight
        : styles.font.fontWeight,
    ),
    padding: `${styles.paddingPx}px`,
    cursor: "pointer",
  };
}
